import React from "react";
import StepPlaceholder from "./StepPlaceholder";

interface StepProps {
  onBack: () => void;
  onNext: () => void;
}

const Step4DeliverySchedule: React.FC<StepProps> = ({
  onBack,
  onNext,
}) => {
  return (
    <StepPlaceholder
      step={4}
      label={
        <>
          Delivery & <br /> Schedule
        </>
      }
      onBack={onBack}
      onNext={onNext}
    />
  );
};

export default Step4DeliverySchedule;